import { apiSend, apiSendJson, apiSendJsonAndFiles } from "@/api/apicommon"

export default {    
    async createDefaultReferences() {
        const method = "POST"
        const endpoint = "/clinical/createDefaultReferences/"
        const json = {
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getRefCommonAlerts() {
        const method = "GET";
        const endpoint = "/appUser/refCommonAlerts";
        return apiSend(method, endpoint);
    },
    async getCurrentAppUser() {
        const method = "POST"
        const endpoint = "/appUser/getCurrentAppUser/"
        const json = {
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getCurrentHealthGroupMembership() {
        const method = "POST"
        const endpoint = "/appUser/getCurrentHealthGroupMembership/"
        const json = {}
        return await apiSendJson(method, endpoint, json)
    },    
    async getHealthGroupMembership(instituteUuid: string) {
        const method = "POST"
        const endpoint = "/appUser/getHealthGroupMembership"
        const json = {
            "instituteUuid" : instituteUuid
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateReferenceText(referenceTextType: string, referenceText: string) {
        const method = "POST"
        const endpoint = "/appUser/updateReferenceText/"
        const json = {
            "referenceTextType": referenceTextType,
            "referenceText": referenceText,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async switchAppUserHealthGroup(relationId: string) {
        const method = "POST"
        const endpoint = "/appUser/switchAppUserHealthGroup/"
        const json = {
            "relationId": relationId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getReferenceForExpression(expressionId: string) {
        const method = "POST"
        const endpoint = "/appUser/getReferenceForExpression/"
        const json = {
            "expressionId": expressionId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateMedicationSuggestion(newSuggestions: string, appUserMedicationId: string) {
        const method = "POST"
        const endpoint = "/appUser/updateMedicationSuggestion/"
        const json = {
            "newSuggestions": newSuggestions,
            "appUserMedicationId": appUserMedicationId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async createMedicationSuggestion(newSuggestions: string, expressionId: string, originalText: string) {
        const method = "PUT"
        const endpoint = "/app-user/medication-suggestions"
        const json = {
            "newSuggestions": newSuggestions,
            "expressionId": expressionId,
            "originalText": originalText,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async createPatientInfos(patientInfos: string, expressionId: string, originalText: string) {
        const method = "PUT"
        const endpoint = "/app-user/patient-infos"
        const json = {
            "patientInfos": patientInfos,
            "expressionId": expressionId,
            "originalText": originalText,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async createPharmacyInfos(pharmacyInfos: string, expressionId: string, originalText: string) {
        const method = "PUT"
        const endpoint = "/app-user/pharmacy-infos"
        const json = {
            "pharmacyInfos": pharmacyInfos,
            "expressionId": expressionId,
            "originalText": originalText,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateAutoUseFirstPatientInfo(autoUseFirstPatientInfo: boolean, expressionId: string, originalText: string) {
        const method = "PUT"
        const endpoint = "/app-user/auto-use-first-patient-info"
        const json = {
            "autoUseFirstPatientInfo": autoUseFirstPatientInfo,
            "expressionId": expressionId,
            "originalText": originalText,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateAutoUseFirstPharmacyInfo(autoUseFirstPharmacyInfo: boolean, expressionId: string, originalText: string) {
        const method = "PUT"
        const endpoint = "/app-user/auto-use-first-pharmacy-info"
        const json = {
            "autoUseFirstPharmacyInfo": autoUseFirstPharmacyInfo,
            "expressionId": expressionId,
            "originalText": originalText,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async createReferenceDocument(refSheetId: string, patientDocumentId: string, title: string) {
        const method = "POST"
        const endpoint = `/app-user/reference-sheets/${refSheetId}/reference-documents`
        const json = {
            "patientDocumentId": patientDocumentId,
            "title": title,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getReferenceDocument(referenceDocumentId: string) {
        const method = "GET"
        const endpoint = `/app-user/reference-documents/${referenceDocumentId}`
        return await apiSend(method, endpoint)
    },
    async getReferenceDocumentFieldPreference(referenceDocumentId: string, uiSelectorId: string) {
        const method = "GET"
        const endpoint = `/app-user/reference-documents/${referenceDocumentId}/ui-selectors/${uiSelectorId}/field-preference`
        return await apiSend(method, endpoint)
    },
    async deleteReferenceDocument(referenceDocumentId: string) {
        const method = "DELETE"
        const endpoint = `/app-user/reference-documents/${referenceDocumentId}`
        return await apiSend(method, endpoint)
    },
    async updateReferenceDocument(referenceDocumentId: string, json: { title?: string }) {
        const method = "PUT"
        const endpoint = `/app-user/reference-documents/${referenceDocumentId}`
        return await apiSendJson(method, endpoint, json)
    },    
    async updateReferenceDocumentFieldPreference(referenceDocumentId: string, uiSelectorId: number, json: { suggestions?: string; autoUseFirst?: boolean }) {
        const method = "PUT"
        const endpoint = `/app-user/reference-documents/${referenceDocumentId}/ui-selectors/${uiSelectorId}/field-preference`
        return await apiSendJson(method, endpoint, json)
    },
    async updateResultReferenceText(resultReferenceId: string, resultReferenceType: string, referenceText: string) {
        const method = "POST"
        const endpoint = "/appUser/updateResultReferenceText/"
        const json = {
            "resultReferenceId": resultReferenceId,
            "resultReferenceType": resultReferenceType,
            "referenceText": referenceText,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateDocumentFieldSuggestions(uiSelectorName: string, suggestions: string) {
        const method = "POST"
        const endpoint = "/appUser/updateDocumentFieldSuggestions/"
        const json = {
            "uiSelectorName": uiSelectorName,
            "suggestions": suggestions,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateAutoUseFirstDocFieldSuggestion(uiSelectorName: string, autoUseFirst: boolean) {
        const method = "POST"
        const endpoint = "/appUser/updateAutoUseFirstDocFieldSuggestion/"
        const json = {
            "uiSelectorName": uiSelectorName,
            "autoUseFirst": autoUseFirst,
        }
        return await apiSendJson(method, endpoint, json)
    },    
    async addRefSheet(triggers: string) {
        const method = "POST"
        const endpoint = "/appUser/addRefSheet/"
        const json = {
            "triggers": triggers,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async deleteRefSheet(appUserResultReferenceId: string) {
        const method = "POST"
        const endpoint = "/appUser/deleteRefSheet/"
        const json = {
            "appUserResultReferenceId": appUserResultReferenceId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async deleteRefSheetFile(appUserResultReferenceFileId: string) {
        const method = "POST"
        const endpoint = "/appUser/deleteRefSheetFile/"
        const json = {
            "appUserResultReferenceFileId": appUserResultReferenceFileId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateRefSheetFileTitle(appUserResultReferenceFileId: string, title: string) {
        const method = "POST"
        const endpoint = "/appUser/updateRefSheetFileTitle/"
        const json = {
            "appUserResultReferenceFileId": appUserResultReferenceFileId,
            "title" : title,
        }
        return await apiSendJson(method, endpoint, json)
    },    
    async deleteExternalLinkFromReferenceSheet(appUserResultReferenceLinkId: string) {
        const method = "POST"
        const endpoint = "/appUser/deleteExternalLinkFromReferenceSheet/"
        const json = {
            "appUserResultReferenceLinkId": appUserResultReferenceLinkId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateExternalLinkTitle(appUserResultReferenceLinkId: string, linkTitle: string) {
        const method = "POST"
        const endpoint = "/appUser/updateExternalLinkTitle/"
        const json = {
            "appUserResultReferenceLinkId": appUserResultReferenceLinkId,
            "linkTitle" : linkTitle,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateExternalLinkUrl(appUserResultReferenceLinkId: string, link: string) {
        const method = "POST"
        const endpoint = "/appUser/updateExternalLinkUrl/"
        const json = {
            "appUserResultReferenceLinkId": appUserResultReferenceLinkId,
            "link" : link,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateAppUserSctLanguage(sctLanguage: string) {
        const method = "POST"
        const endpoint = "/appUser/updateAppUserSctLanguage/"
        const json = {
            "sctLanguage": sctLanguage,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateAppUserMenuLanguage(menuLanguageIso: string) {
        const method = "POST"
        const endpoint = "/appUser/updateAppUserMenuLanguage/"
        const json = {
            "menuLanguageIso": menuLanguageIso,
        }
        return await apiSendJson(method, endpoint, json)
    },


    async updateSuggestionsShowHumanBody(suggestionsShowHumanBody: boolean) {
        const method = "POST"
        const endpoint = "/appUser/updateSuggestionsShowHumanBody/"
        const json = {
            "suggestionsShowHumanBody": suggestionsShowHumanBody,
        }
        return await apiSendJson(method, endpoint, json)
    },

    async updateSuggestionsShowNeuro(suggestionsShowNeuro: boolean) {
        const method = "POST"
        const endpoint = "/appUser/updateSuggestionsShowNeuro/"
        const json = {
            "suggestionsShowNeuro": suggestionsShowNeuro,
        }
        return await apiSendJson(method, endpoint, json)
    },

    async updateSuggestionsShowEnt(suggestionsShowEnt: boolean) {
        const method = "POST"
        const endpoint = "/appUser/updateSuggestionsShowEnt/"
        const json = {
            "suggestionsShowEnt": suggestionsShowEnt,
        }
        return await apiSendJson(method, endpoint, json)
    },

    async updateSuggestionsShowLymph(suggestionsShowLymph: boolean) {
        const method = "POST"
        const endpoint = "/appUser/updateSuggestionsShowLymph/"
        const json = {
            "suggestionsShowLymph": suggestionsShowLymph,
        }
        return await apiSendJson(method, endpoint, json)
    },

    async updateSuggestionsShowThorax(suggestionsShowThorax: boolean) {
        const method = "POST"
        const endpoint = "/appUser/updateSuggestionsShowThorax/"
        const json = {
            "suggestionsShowThorax": suggestionsShowThorax,
        }
        return await apiSendJson(method, endpoint, json)
    },

    async updateSuggestionsShowAbdomen(suggestionsShowAbdomen: boolean) {
        const method = "POST"
        const endpoint = "/appUser/updateSuggestionsShowAbdomen/"
        const json = {
            "suggestionsShowAbdomen": suggestionsShowAbdomen,
        }
        return await apiSendJson(method, endpoint, json)
    },

    async updateClinicalEntriesReducedByDefault(clinicalEntriesReducedByDefault: boolean) {
        const method = "POST"
        const endpoint = "/appUser/updateClinicalEntriesReducedByDefault/"
        const json = {
            "clinicalEntriesReducedByDefault": clinicalEntriesReducedByDefault,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getRefSheet(refSheetId: string) {
        const method = "POST"
        const endpoint = "/clinical/getRefSheet/"
        const json = {
            "refSheetId": refSheetId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getRefSheetsForExpr(expressionId: string) {
        const method = "POST"
        const endpoint = "/clinical/getRefSheetsForExpr/"
        const json = {
            "expressionId": expressionId
        }
        return await apiSendJson(method, endpoint, json)
    },    
    async allReferenceSheetsToDto() {
        const method = "POST"
        const endpoint = "/clinical/allReferenceSheetsToDto/"
        const json = {
        }
        return await apiSendJson(method, endpoint, json)
    },    
    async getRefSheetsForCclGroup(conclusionGroupId: string) {
        const method = "POST"
        const endpoint = "/clinical/getRefSheetsForCclGroup/"
        const json = {
            "conclusionGroupId": conclusionGroupId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addExternalLinkToReferenceSheet(appUserResultReferenceId: string, linkTitle: string, link: string) {
        const method = "POST"
        const endpoint = "/appUser/addExternalLinkToReferenceSheet/"
        const json = {
            "appUserResultReferenceId": appUserResultReferenceId,
            "linkTitle": linkTitle,
            "link": link,
        }        
        return await apiSendJson(method, endpoint, json)
    },
    async addFilesToRefSheet(appUserResultReferenceId: string, files: File[]) {
        const method = "POST"
        const endpoint = "/appUser/addFilesToRefSheet/"
        const json = {
            "appUserResultReferenceId": appUserResultReferenceId,
        }        
        return await apiSendJsonAndFiles(method, endpoint, json, files)
    },
    async addPatientFilesToRefSheet(appUserResultReferenceId: string, files: File[]) {
        const method = "POST"
        const endpoint = "/appUser/addPatientFilesToRefSheet/"
        const json = {
            "appUserResultReferenceId": appUserResultReferenceId,
        }        
        return await apiSendJsonAndFiles(method, endpoint, json, files)
    },    
    async getAppUserReferenceFileStream(appUserResultReferenceFileId: string) {
        const method = "POST"
        const endpoint = "/appUser/getAppUserReferenceFileStream/"
        const json = {
            "appUserResultReferenceFileId": appUserResultReferenceFileId
        }
        const isBinary = true
        return await apiSendJson(method, endpoint, json, isBinary)
    },
    async allDocumentGroupsToDto() {
        const method = "POST"
        const endpoint = "/appUser/allDocumentGroupsToDto/"
        const json = {
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addLuActFavorite(luActFavorite: string) {
        const method = "POST"
        const endpoint = "/appUser/addLuActFavorite/"
        const json = {
            "luActFavorite": luActFavorite,
        }
        return await apiSendJson(method, endpoint, json)
    },    
    async addCustomLuAct(description: string) {
        const method = "POST"
        const endpoint = "/appUser/addCustomLuAct/"
         const json = {
            "description": description,
        }     
        return await apiSendJson(method, endpoint, json)
    },
    async editCustomLuAct(appUserLuActId: string, description: string) {
        const method = "POST"
        const endpoint = "/appUser/editCustomLuAct/"
         const json = {
             "appUserLuActId": appUserLuActId,
            "description": description,
        }     
        return await apiSendJson(method, endpoint, json)
    },
    async deleteCustomLuAct(appUserLuActId: string) {
        const method = "POST"
        const endpoint = "/appUser/deleteCustomLuAct/"
         const json = {
            "appUserLuActId": appUserLuActId,
        }     
        return await apiSendJson(method, endpoint, json)
    },
 
}
